<template>
  <Layout>
    <div class="top-actions" v-if="!loading">
      <div class="row">
        <div class="col-6">
          <div class="flex justify-start">
            <q-btn color="blue" @click="$router.push({name: 'blackbook_list'})" :disabled="paymentLoading">
              <template>
                <div>
                  <q-icon name="fas fa-arrow-left" class="q-mr-sm"/>
                  <span class="q-gutter-md">
                    <span>Back to list</span>
                  </span>
                </div>
              </template>
            </q-btn>
          </div>
        </div>
        <div class="col-6">
          <div class="flex justify-end">
            <div v-if="true">
              <q-btn color="secondary"
                     class="btn q-mr-sm"
                     v-if="getPayable()"
                     :disable="paymentLoading"
                     :loading="paymentLoading">
                <template>
                  <div>
                    <q-icon name="fas fa-lock" class="q-mr-sm"/>
                    <span class="q-gutter-md" @click.async="paymentWithStripe()">
                      <span>Secure Payment</span>
                    </span>
                  </div>
                </template>
              </q-btn>
              <q-tooltip>
                <div>Secure payment</div>
              </q-tooltip>
            </div>
            <q-chip square color="green" text-color="white" v-else>Paid</q-chip>
            <q-btn color="green"
                   v-if="this.item.completed_at !== null"
                   :loading="excelLoading"
                   :disable="excelLoading"
                   @click.async="exportExcel">
              <template>
                <div>
                  <q-icon name="fas fa-file-excel" class="q-mr-sm"/>
                  <span class="q-gutter-md">
                    <span>Export to Excel</span>
                  </span>
                </div>
              </template>
            </q-btn>
          </div>
        </div>
      </div>
    </div>
    <div :class="`box${paymentLoading ? ' loading' : ''}`">
      <div class="flex justify-center" v-if="loading">
        <q-spinner-facebook color="primary" size="40px"/>
      </div>
      <div v-else>
        <div class="row">
          <div class="col">
            <table class="table table-summary">
              <tbody>
              <tr>
                <th>ID:</th>
                <td>{{ item.id }}</td>
              </tr>
              <tr>
                <th>Vehicles:</th>
                <td>{{ item.items.length }}</td>
              </tr>
              <tr>
                <th>Amount:</th>
                <td>{{ item.amount | toCurrency }}</td>
              </tr>
              <tr>
                <th>Paid:</th>
                <td>
                  <q-badge color="red" text-color="white" label="UNPAID" v-if="item.paid_at === null"/>
                  <q-badge color="green" text-color="white" v-else>
                    PAID: {{ item.paid_at | dateTimeFormat }}
                  </q-badge>
                </td>
              </tr>
              <tr>
                <th>Result:</th>
                <td>
                  <q-badge :color="getResultColor(item.result)">
                    {{ item.result.toUpperCase() }}
                    <q-tooltip v-if="item.message !== null">
                      <div>{{ item.message }}</div>
                    </q-tooltip>
                  </q-badge>
                </td>
              </tr>
              <tr>
                <th>Message:</th>
                <td>{{ item.message ?? '-' }}</td>
              </tr>
              <tr>
                <th>Completed at:</th>
                <td>
                  <span v-if="item.completed_at === null">-</span>
                  <span v-else>{{ item.completed_at | dateTimeFormat }}</span>
                </td>
              </tr>
              <tr>
                <th>Created at:</th>
                <td>{{ item.created_at | dateTimeFormat }}</td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
        <hr/>
        <div class="row">
          <div class="col">
            <div class="table-responsive" ref="tablev1">
              <q-btn
                v-if="item.items.length > 0"
                class="glossy custom-item-icon left-0"
                style="margin-left: -10px"
                @mousedown="shiftLeft()"
                @mouseup="shiftLeftEnd()"
                round
                color="primary"
                icon="fas fa-arrow-left"
              />
              <q-btn
                v-if="item.items.length > 0"
                class="glossy custom-item-icon right-0"
                @mouseup="shiftRightEnd()"
                @mousedown="shiftRight()"
                round
                color="primary"
                icon="fas fa-arrow-right"
              />
              <table class="table table-vehicles">
                <thead>
                <tr>
                  <th colspan="14">Vehicle</th>
                  <th colspan="4">BlackBook Retail</th>
                  <th colspan="4">BlackBook WholeSale</th>
                  <th colspan="5">Manheim WholeSale</th>
                  <th colspan="6">Financial Info</th>
                </tr>
                <tr>
                  <th>VIN</th>
                  <th>Unit</th>
                  <th>Company</th>
                  <th>Location</th>
                  <th>Make</th>
                  <th>Model</th>
                  <th>Model Detail</th>
                  <th>Model Year</th>
                  <th>Condition</th>
                  <th>Color</th>
                  <th>Mileage</th>
                  <th>State</th>
                  <th>In Service Date</th>
                  <th>Status</th>
                  <th>XClean</th>
                  <th>Clean</th>
                  <th>Average</th>
                  <th>Rough</th>
                  <th>XClean</th>
                  <th>Clean</th>
                  <th>Average</th>
                  <th>Rough</th>
                  <th>AVG CR</th>
                  <th>Above</th>
                  <th>Average</th>
                  <th>Below</th>
                  <th>Weekly Change</th>
                  <th>Estimated Payoff</th>
                  <th>Estimated Cap Cost</th>
                  <th>Initial Purchase Price</th>
                  <th>Monthly Payment</th>
                  <th>Remaining Months</th>
                  <th>Finance Source</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="bbItem in item.items">
                  <td>{{ bbItem.vehicle.vin }}</td>
                  <td>{{ bbItem.vehicle.unit ?? '-' }}</td>
                  <td>{{ bbItem.vehicle.company.name }}</td>
                  <td>{{ bbItem.vehicle.location.name }}</td>
                  <td>{{ bbItem.vehicle.brand.name }}</td>
                  <td>{{ bbItem.vehicle.model.name }}</td>
                  <td>{{ bbItem.vehicle.model_detail.name }}</td>
                  <td>{{ bbItem.vehicle.model_year }}</td>
                  <td>{{ getConditionLabelByValue(bbItem.vehicle.condition) }}</td>
                  <td>{{ bbItem.vehicle.color }}</td>
                  <td>{{ bbItem.mileage | formatNumber }}</td>
                  <td>{{ bbItem.state }}</td>
                  <td>
                    <span v-if="bbItem.vehicle.in_service_date === null">-</span>
                    <span v-else>{{ bbItem.vehicle.in_service_date | dateTimeFormat }}</span>
                  </td>
                  <td>{{ getLabelByValue(bbItem.vehicle.status) }}</td>
                  <td>{{ getBlackbookValue(bbItem.data, 'adjusted_retail_xclean') | formatPrice }}</td>
                  <td>{{ getBlackbookValue(bbItem.data, 'adjusted_retail_clean') | formatPrice }}</td>
                  <td>{{ getBlackbookValue(bbItem.data, 'adjusted_retail_avg') | formatPrice }}</td>
                  <td>{{ getBlackbookValue(bbItem.data, 'adjusted_retail_rough') | formatPrice }}</td>
                  <td>{{ getBlackbookValue(bbItem.data, 'adjusted_whole_xclean') | formatPrice }}</td>
                  <td>{{ getBlackbookValue(bbItem.data, 'adjusted_whole_clean') | formatPrice }}</td>
                  <td>{{ getBlackbookValue(bbItem.data, 'adjusted_whole_avg') | formatPrice }}</td>
                  <td>{{ getBlackbookValue(bbItem.data, 'adjusted_whole_rough') | formatPrice }}</td>
                  <td>{{ bbItem.grade }}</td>
                  <td>{{ getMarketValueItem(bbItem.vehicle, 'excellent') | formatPrice }}</td>
                  <td>{{ getMarketValueItem(bbItem.vehicle, 'good') | formatPrice }}</td>
                  <td>{{ getMarketValueItem(bbItem.vehicle, 'fair') | formatPrice }}</td>
                  <td v-html="getWeeklyChange(bbItem.vehicle)"></td>
                  <td>
                    <span v-if="bbItem.vehicle.finance === null">-</span>
                    <span v-else>{{ bbItem.vehicle.finance.payoff | formatPrice }}</span>
                  </td>
                  <td>
                    <span v-if="bbItem.vehicle.finance === null">-</span>
                    <span v-else>{{ bbItem.vehicle.finance.estimated_cap_cost | formatPrice }}</span>
                  </td>
                  <td>
                    <span v-if="bbItem.vehicle.finance === null">-</span>
                    <span v-else>{{ bbItem.vehicle.finance.purchase_amount | formatPrice }}</span>
                  </td>
                  <td>
                    <span v-if="bbItem.vehicle.finance === null">-</span>
                    <span v-else>{{ bbItem.vehicle.finance.monthly_payment | formatPrice }}</span>
                  </td>
                  <td>
                    <span v-if="bbItem.vehicle.finance === null">-</span>
                    <span v-else>{{ bbItem.vehicle.finance.remaining }}</span>
                  </td>
                  <td>
                    <span v-if="bbItem.vehicle.finance === null">-</span>
                    <span v-else>{{ bbItem.vehicle.finance.financing_company_name ?? '-' }}</span>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <secure-payment-modal :on-success="() => handleSuccess()"
                          :on-close="() => handleClosePaymentModal()"
                          :show="paymentModalOpen"
                          :data="item"
                          :loading="paymentLoading"
                          v-if="item !== null"></secure-payment-modal>
  </Layout>
</template>

<script>
import Layout from "@/components/Layout.vue";
import axios from "@/axios";
import {getConditionLabelByValue, getLabelByValue} from "@/enums";
import SecurePaymentModal from "@/components/blackbook/SecurePaymentModal.vue";

export default {
  components: {SecurePaymentModal, Layout},
  data() {
    return {
      loading: true,
      paymentLoading: false,
      excelLoading: false,
      paymentModalOpen: false,
      item: null,
    }
  },
  metaInfo() {
    return {
      title: 'Blackbook | FMS',
      meta: [
        {
          name: 'description',
          content: ''
        },
        {
          property: 'og:title',
          content: 'Blackbook | FMS'
        },
        {property: 'og:site_name', content: 'FMS'},
        {property: 'og:type', content: 'website'},
        {name: 'robots', content: 'index,follow'}
      ]
    }
  },
  async mounted() {
    await this.getItem();
    await this.results();
  },
  methods: {
    getConditionLabelByValue,
    getLabelByValue,
    async getItem() {
      try {
        const {data} = await axios.get(`/blackbook/${this.$route.params.id}`)
        this.item = data.data
        if (this.$route.query.payment && this.item.paid_at === null) {
          await this.paymentWithStripe()
        } else {
          if (this.item.paid_at === null && this.$route.query.status === undefined) {
            this.paymentModalOpen = true
          }
        }
      } catch (e) {
        console.log('Error', e)
        this.$q.notify({
          color: 'negative',
          position: 'top',
          message: 'Error',
          icon: 'fas fa-exclamation-triangle'
        })
        await this.$router.push({name: 'blackbook_list'})
      } finally {
        this.loading = false
      }
    },
    getPayable() {
      return this.item?.paid_at === null && this.$route.query.status !== 'success';
    },
    handleClosePaymentModal() {
      this.paymentModalOpen = false;
    },
    handleSuccess() {
      this.handleClosePaymentModal();
      this.paymentWithStripe();
    },
    getMarketValueItem(vehicle, prop) {
      if (vehicle.last_mileage_record === null) return null;
      if (vehicle.last_mileage_record.market_values.length === 0) return null;
      const marketValue = vehicle.last_mileage_record.market_values.find(value => value.provider === "manheim");
      return marketValue ? marketValue[prop] : null;
    },
    getWeeklyChange(vehicle) {
      const weeklyChange = this.getMarketValueItem(vehicle, `${vehicle.condition}_weekly_change`) ?? 0;
      if (weeklyChange > 0) {
        return `<span class="text-green">+${weeklyChange}</span>`;
      } else if (weeklyChange < 0) {
        return `<span class="text-red">${weeklyChange}</span>`;
      } else {
        return `<span class="text-blue-grey">${weeklyChange}</span>`;
      }
    },
    getBlackbookValue(data, prop) {
      try {
        return data.used_vehicles.used_vehicle_list[0][prop]
      } catch (e) {
        return '-';
      }
    },
    async paymentWithStripe() {
      try {
        this.paymentLoading = true;
        const {data} = await axios.get(`blackbook/${this.item.id}/payment/stripe`);
        window.location.href = data.data.url;
      } catch (e) {
        this.$q.notify({
          type: 'negative',
          position: 'top',
          progress: true,
          message: e.response.data.message,
        });
        this.paymentLoading = false;
      }
    },
    async results() {
      if (!this.$route.query.transaction) {
        return;
      }

      this.loading = true;
      setTimeout(async () => {
        if (this.$route.query.status === 'success') {
          this.$q.notify({
            type: 'positive',
            position: 'top',
            progress: true,
            message: 'Payment successful',
          });
          setTimeout(async () => {
            await this.redirectBlackbook();
          }, 2000);
        } else if (this.$route.query.status === 'cancel') {
          await this.cancel();
        }

        this.loading = false;
      }, 3000);
    },
    getResultColor(val) {
      if (val === 'success') {
        return 'green';
      } else if (val === 'failed') {
        return 'red';
      } else {
        return 'grey';
      }
    },
    async redirectBlackbook() {
      await this.$router.push(`/vehicle-advanced/${this.item.id}`);
    },
    async cancel() {
      try {
        this.paymentLoading = true;
        await axios.get(`blackbook/${this.item.id}/transaction/${this.$route.query.transaction}/cancel`);
        this.$q.notify({
          type: 'positive',
          position: 'top',
          progress: true,
          message: 'Payment canceled',
        });
      } catch (e) {
        this.$q.notify({
          type: 'negative',
          position: 'top',
          progress: true,
          message: e.response.data.message,
        });
      } finally {
        this.paymentLoading = false;
        await this.redirectBlackbook();
      }
    },
    async exportExcel() {
      try {
        this.excelLoading = true
        const { data } = await axios.get(`blackbook/${this.$route.params.id}/export-excel`, {
          responseType: 'blob'
        })
        const url = window.URL.createObjectURL(new Blob([data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `blackbook-${this.$route.params.id}.xlsx`)
        document.body.appendChild(link)
        link.click()
      } catch (error) {
      } finally {
        this.excelLoading = false
      }
    },
    shiftRight() {
      this.rightInterval = setInterval(() => {
        this.$refs.tablev1.scrollLeft += 50
      }, 50)
    },
    shiftRightEnd() {
      clearInterval(this.rightInterval)
    },
    shiftLeft() {
      this.leftInterval = setInterval(() => {
        this.$refs.tablev1.scrollLeft -= 50
      }, 50)
    },
    shiftLeftEnd() {
      clearInterval(this.leftInterval)
    },
  },
}
</script>

<style scoped lang="scss">
.top-actions {
  position: absolute;
  top: 10px;
  right: 0;
  padding: 10px 25px;
  width: 100%;
  height: 60px;

  .selection {
    margin: 8px 15px 0;
  }

  .q-btn {
    .q-icon {
      font-size: 14px;
    }
  }
}

.box {
  position: relative;
  margin-top: 50px;
  width: 100%;
  max-height: calc(100vh - 220px);
  overflow: auto;

  &.loading {
    opacity: .5;
  }
}

.table-responsive {
  overflow-x: auto;

  > .custom-item-icon {
    z-index: 999;
    position: fixed;
    top: 60%;
  }
}

table.table-summary {
  border-collapse: collapse;
  border: 1px solid #ddd;
  width: 100%;
  height: auto !important;

  tr {
    border: 1px solid #ddd;
    background-color: #fff;
  }

  th, td {
    padding: 5px 10px !important;
  }

  th {
    width: 25%;
    text-align: right !important;
    cursor: auto !important;
  }

  td {
    width: 75%;
    text-align: left !important;
    cursor: auto !important;
  }
}

hr {
  margin: 20px 0;
  height: 0;
  border: 0;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  border-bottom: 1px solid rgba(255, 255, 255, 0.3);
}

table.table-vehicles {
  border-collapse: collapse;
  border: 1px solid #b6b2b2;
  width: 100%;
  height: auto !important;

  tr {
    border: 1px solid #ddd;
    background-color: #fff;
  }

  th, td {
    padding: 5px 10px !important;
    border: 1px solid #b6b2b2;
    cursor: auto !important;
  }

  > thead {
    tr {
      border: 1px solid #b6b2b2;
      background-color: #e8e8e8;
    }

    th {
      padding: 5px 10px !important;
      border: 1px solid #b6b2b2;
      min-width: 180px;
      cursor: auto !important;
    }
  }

  > tbody {
    > tr {
      &:nth-of-type(even) {
        background-color: #f2f2f2 !important;

        &:hover {
          background-color: #dcecea !important;
        }
      }

      &:hover {
        background-color: #eAf6f5ff !important;
      }
    }
  }
}
</style>
